export const WorldBadgeColors = [
  {dark: "#F5A742", light: "#F5A742"},
  {dark: "#15C238", light: "#15C238"},
  {dark: "#B1C215", light: "#B1C215"},
  {dark: "#70b8ff", light: "#70b8ff"},
  {dark: "#ff697f", light: "#ff697f"},
  {dark: "#69ffd4", light: "#69ffd4"},
  {dark: "#15A8C2", light: "#15A8C2"},
  {dark: "#B23BF7", light: "#B23BF7"},
  {dark: "#BEA316", light: "#BEA316"},
  {dark: "#F31677", light: "#F31677"},
];

export const BadgeColors = {
  Adamantoise: {
    dark: "#F5A742",
    light: "#F5A742"
  },
  Cactuar: {
    dark: "#15C238",
    light: "#15C238"
  },
  Faerie: {
    dark: "#B1C215",
    light: "#B1C215"
  },
  Gilgamesh: {
    dark: "#4287F5",
    light: "#4287F5"
  },
  Jenova: {
    dark: "#FF3636",
    light: "#FF3636"
  },
  Midgardsormr: {
    dark: "#153EC2",
    light: "#153EC2"
  },
  Sargatanas: {
    dark: "#15A8C2",
    light: "#15A8C2"
  },
  Siren: {
    dark: "#B23BF7",
    light: "#B23BF7"
  },


  Balmung: {
    dark: "#F5A742",
    light: "#F5A742"
  },
  Brynhildr: {
    dark: "#15C238",
    light: "#15C238"
  },
  Coeurl: {
    dark: "#B1C215",
    light: "#B1C215"
  },
  Diabolos: {
    dark: "#4287F5",
    light: "#4287F5"
  },
  Goblin: {
    dark: "#FF3636",
    light: "#FF3636"
  },
  Malboro: {
    dark: "#153EC2",
    light: "#153EC2"
  },
  Mateus: {
    dark: "#15A8C2",
    light: "#15A8C2"
  },
  Zalera: {
    dark: "#B23BF7",
    light: "#B23BF7"
  },


  Behemoth: {
    dark: "#F5A742",
    light: "#F5A742"
  },
  Excalibur: {
    dark: "#15C238",
    light: "#15C238"
  },
  Exodus: {
    dark: "#B1C215",
    light: "#B1C215"
  },
  Famfrit: {
    dark: "#4287F5",
    light: "#4287F5"
  },
  Hyperion: {
    dark: "#FF3636",
    light: "#FF3636"
  },
  Lamia: {
    dark: "#153EC2",
    light: "#153EC2"
  },
  Leviathan: {
    dark: "#15A8C2",
    light: "#15A8C2"
  },
  Ultros: {
    dark: "#B23BF7",
    light: "#B23BF7"
  },


  Cerberus: {
    dark: "#F5A742",
    light: "#F5A742"
  },
  Louisoix: {
    dark: "#15C238",
    light: "#15C238"
  },
  Moogle: {
    dark: "#B1C215",
    light: "#B1C215"
  },
  Omega: {
    dark: "#4287F5",
    light: "#4287F5"
  },
  Ragnarok: {
    dark: "#FF3636",
    light: "#FF3636"
  },
  Spriggan: {
    dark: "#153EC2",
    light: "#153EC2"
  },


  Lich: {
    dark: "#F5A742",
    light: "#F5A742"
  },
  Odin: {
    dark: "#15C238",
    light: "#15C238"
  },
  Phoenix: {
    dark: "#B1C215",
    light: "#B1C215"
  },
  Shiva: {
    dark: "#4287F5",
    light: "#4287F5"
  },
  Twintania: {
    dark: "#FF3636",
    light: "#FF3636"
  },
  Zodiark: {
    dark: "#153EC2",
    light: "#153EC2"
  },


  Bismarck: {
    dark: "#F5A742",
    light: "#F5A742"
  },
  Ravana: {
    dark: "#15C238",
    light: "#15C238"
  },
  Sephirot: {
    dark: "#B1C215",
    light: "#B1C215"
  },
  Sophia: {
    dark: "#4287F5",
    light: "#4287F5"
  },
  Zurvan: {
    dark: "#FF3636",
    light: "#FF3636"
  },


  Aegis: {
    dark: "#F5A742",
    light: "#F5A742"
  },
  Atomos: {
    dark: "#15C238",
    light: "#15C238"
  },
  Carbuncle: {
    dark: "#B1C215",
    light: "#B1C215"
  },
  Garuda: {
    dark: "#4287F5",
    light: "#4287F5"
  },
  Gungnir: {
    dark: "#FF3636",
    light: "#FF3636"
  },
  Kujata: {
    dark: "#153EC2",
    light: "#153EC2"
  },
  Ramuh: {
    dark: "#15A8C2",
    light: "#15A8C2"
  },
  Tonberry: {
    dark: "#B23BF7",
    light: "#B23BF7"
  },
  Typhon: {
    dark: "#E811E8",
    light: "#E811E8"
  },
  Unicorn: {
    dark: "#BEA316",
    light: "#BEA316"
  },


  Alexander: {
    dark: "#F5A742",
    light: "#F5A742"
  },
  Bahamut: {
    dark: "#15C238",
    light: "#15C238"
  },
  Durandal: {
    dark: "#B1C215",
    light: "#B1C215"
  },
  Fenrir: {
    dark: "#4287F5",
    light: "#4287F5"
  },
  Ifrit: {
    dark: "#FF3636",
    light: "#FF3636"
  },
  Ridill: {
    dark: "#153EC2",
    light: "#153EC2"
  },
  Tiamat: {
    dark: "#15A8C2",
    light: "#15A8C2"
  },
  Ultima: {
    dark: "#B23BF7",
    light: "#B23BF7"
  },
  Valefor: {
    dark: "#E811E8",
    light: "#E811E8"
  },
  Yojimbo: {
    dark: "#BEA316",
    light: "#BEA316"
  },
  Zeromus: {
    dark: "#F31677",
    light: "#F31677"
  },


  Anima: {
    dark: "#F5A742",
    light: "#F5A742"
  },
  Asura: {
    dark: "#15C238",
    light: "#15C238"
  },
  Belias: {
    dark: "#B1C215",
    light: "#B1C215"
  },
  Chocobo: {
    dark: "#4287F5",
    light: "#4287F5"
  },
  Hades: {
    dark: "#FF3636",
    light: "#FF3636"
  },
  Ixion: {
    dark: "#153EC2",
    light: "#153EC2"
  },
  Mandragora: {
    dark: "#15A8C2",
    light: "#15A8C2"
  },
  Masamune: {
    dark: "#B23BF7",
    light: "#B23BF7"
  },
  Pandaemonium: {
    dark: "#E811E8",
    light: "#E811E8"
  },
  Shinryu: {
    dark: "#BEA316",
    light: "#BEA316"
  },
  Titan: {
    dark: "#F31677",
    light: "#F31677"
  },


  红玉海: {
    dark: "#F5A742",
    light: "#F5A742"
  },
  神意之地: {
    dark: "#15C238",
    light: "#15C238"
  },
  拉诺西亚: {
    dark: "#B1C215",
    light: "#B1C215"
  },
  幻影群岛: {
    dark: "#4287F5",
    light: "#4287F5"
  },
  萌芽池: {
    dark: "#FF3636",
    light: "#FF3636"
  },
  宇宙和音: {
    dark: "#153EC2",
    light: "#153EC2"
  },
  沃仙曦染: {
    dark: "#15A8C2",
    light: "#15A8C2"
  },
  晨曦王座: {
    dark: "#B23BF7",
    light: "#B23BF7"
  },


  白银乡: {
    dark: "#F5A742",
    light: "#F5A742"
  },
  白金幻象: {
    dark: "#15C238",
    light: "#15C238"
  },
  神拳痕: {
    dark: "#B1C215",
    light: "#B1C215"
  },
  潮风亭: {
    dark: "#4287F5",
    light: "#4287F5"
  },
  旅人栈桥: {
    dark: "#FF3636",
    light: "#FF3636"
  },
  拂晓之间: {
    dark: "#153EC2",
    light: "#153EC2"
  },
  龙巢神殿: {
    dark: "#15A8C2",
    light: "#15A8C2"
  },
  梦羽宝境: {
    dark: "#B23BF7",
    light: "#B23BF7"
  },


  紫水栈桥: {
    dark: "#F5A742",
    light: "#F5A742"
  },
  延夏: {
    dark: "#15C238",
    light: "#15C238"
  },
  静语庄园: {
    dark: "#B1C215",
    light: "#B1C215"
  },
  摩杜纳: {
    dark: "#4287F5",
    light: "#4287F5"
  },
  海猫茶屋: {
    dark: "#FF3636",
    light: "#FF3636"
  },
  柔风海湾: {
    dark: "#153EC2",
    light: "#153EC2"
  },
  琥珀原: {
    dark: "#15A8C2",
    light: "#15A8C2"
  },


  水晶塔: {
    dark: "#F5A742",
    light: "#F5A742"
  },
  银泪湖: {
    dark: "#15C238",
    light: "#15C238"
  },
  太阳海岸: {
    dark: "#B1C215",
    light: "#B1C215"
  },
  伊修加德: {
    dark: "#4287F5",
    light: "#4287F5"
  },
  红茶川: {
    dark: "#FF3636",
    light: "#FF3636"
  },
}
